module.exports = __webpack_public_path__ + "static/media/chrome_logo.b3d27101.png";